module.exports = __webpack_public_path__ + "img/show__button__arrow__portfolio.20d3cee1.svg";